import { ExamPrice } from "./exam-price";
import { Certificate } from "./certificate";
import { ExamComputerBased } from "./computer-based";
export class Exam {
    constructor(parentWrapper) {
        this.parentWrapper = parentWrapper;
        this.id = parseInt(this.parentWrapper.data("id"));
        this.certificate = this.createCertificate();
        this.price = new ExamPrice(this.id, this.name, this.parentWrapper.find(".price"));
        this.computerBased = new ExamComputerBased(this.id, this.parentWrapper.find(".computer-based"));
        this.name = this.parentWrapper.find("label").html();
        this.parentWrapper
            .find(".delete")
            .on("click", () => (this.price.empty = true));
    }
    set partner(exam) {
        if (exam === undefined) {
            this.price.partner = this.computerBased.partner = undefined;
            this.price.focus();
            return;
        }
        this.price.partner = exam.price;
        if (exam.price.partner === undefined) {
            exam.price.partner = this.price;
        }
        this.computerBased.partner = exam.computerBased;
        if (exam.computerBased.partner === undefined) {
            exam.computerBased.partner = this.computerBased;
        }
    }
    createCertificate() {
        const id = parseInt(this.parentWrapper.data("certificateId"));
        const name = this.parentWrapper.data("certificateName");
        return new Certificate(id, name);
    }
    get selected() {
        return !this.price.empty;
    }
    set visible(value) {
        this.parentWrapper.css("display", value ? "block" : "none");
    }
}
